import { doc, getDoc } from "firebase/firestore";
import { ParsedToken } from "firebase/auth";

// services
import { firestoreRegionDb } from "../../services/firebase.init";

// utilities
import {
  getGlobalUserAccessKey,
  getTargetFromAccessKey,
} from "wombat-global/src/utilities";
import { getAuthorizationTargetsFromClaim } from "./getAuthorizationTargetsFromClaim";

// constants
import { USERS_COLLECTION } from "wombat-global/src/constants";

// types
import {
  IClientTarget,
  IGlobalUserEntity,
  ISiteTarget,
  ITenantTarget,
  PermissionsClaim,
} from "wombat-global/src/typings";

export async function getPriorityTarget(
  claims: ParsedToken & PermissionsClaim,
): Promise<IClientTarget | ISiteTarget | ITenantTarget | undefined> {
  const targetKeys = getAuthorizationTargetsFromClaim(claims);

  const userDoc = await getDoc(
    doc(firestoreRegionDb.us, `${USERS_COLLECTION}/${claims.sub}`),
  )
    .then((d) => d.data() as IGlobalUserEntity)
    .catch((err) => {
      // oxlint-disable-next-line no-console
      console.error("ROUTER REDIRECT", claims.sub, err);
    });

  const access = userDoc?.access || {};

  const homeTarget =
    (userDoc?.homeTarget &&
      access[userDoc.homeTarget] &&
      getTargetFromAccessKey(userDoc.homeTarget)) ||
    undefined;
  if (homeTarget) {
    return homeTarget;
  }

  const authTarget =
    (userDoc?.linkedAuthenticationTarget &&
      access[userDoc.linkedAuthenticationTarget] &&
      getTargetFromAccessKey(userDoc.linkedAuthenticationTarget)) ||
    undefined;
  if (authTarget) {
    return authTarget;
  }

  const priorityTarget = targetKeys.find(
    ({ perm, ...target }) => access[getGlobalUserAccessKey(target)],
  );
  if (priorityTarget) {
    const { perm, ...target } = priorityTarget;
    return target;
  }

  const firstAccessKey = Object.keys(access)[0];
  return firstAccessKey ? getTargetFromAccessKey(firstAccessKey) : undefined;
}
